import { SearchServiceAdministrationComponent } from './search-service-administration/search-service-administration.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';

const routes: Routes = [
    {
        path: 'search',
        component: SearchServiceAdministrationComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ServiceAdministrationRoutingModule {}
